import { render, staticRenderFns } from "./addResourceStoreSpecification.vue?vue&type=template&id=72af2a10&scoped=true"
import script from "./addResourceStoreSpecification.vue?vue&type=script&lang=js"
export * from "./addResourceStoreSpecification.vue?vue&type=script&lang=js"
import style0 from "./addResourceStoreSpecification.vue?vue&type=style&index=0&id=72af2a10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72af2a10",
  null
  
)

export default component.exports